import React from 'react';
import { Skeleton as MantineSkeleton } from '@mantine/core';
import styled, { keyframes } from 'styled-components';
import { themeColor } from '../theme/colors';

export interface SkeletonProps {
  height?: number;
  width?: number | string;
}

const skeletonFade = keyframes`
  0%,
  100% {
    opacity: 0.3;
  }

  50% {
    opacity: 0.5;
  }
`;

const StyledSkeleton = styled(MantineSkeleton)`
  &::after {
    background-color: ${themeColor('gray')};
    animation: ${skeletonFade} 1.8s infinite;
  }
`;

export function SkeletonFilled({ height = 20 }: { height?: number }) {
  return <StyledSkeleton height={`${height}px`} width="100%" />;
}

export default function Skeleton({ height = 20, width }: SkeletonProps) {
  const effectiveWidth = typeof width === 'number' ? `${width}px` : width;
  return <StyledSkeleton height={`${height}px`} width={effectiveWidth} />;
}
